<template>
  <!-- 小程序背景图 -->
    <!-- 头部操作 -->
  <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">>
    <el-button type="primary" size="large" @click="addBackground"
      ><el-icon><Plus /></el-icon>添加</el-button
    >
    <el-button type="danger" v-if="isDelect" size="large" plain @click="deletes"
      >批量删除</el-button
    >
  </el-button-group>

     <!-- 表格组件 -->
     <div class="FocusFigure">
        <TableList
            componentTableId="FocusFigureList"
            @update-list="updateList"
            excelName="小程序背景图列表"
            :table-data="tableData"
            :header-data="headerData"
            :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
            :loading="loading"
            :loading-text="loadingText"
            :empty-text="emptyText"
            @handleEdit="editFnc"
            @searchFnc="searchFnc"
            @openContent="openContent"
            @handleSelection="handleSelection"
            @changeCascader="changeCascader"
            @changeRelevance="changeRelevance"
        >
         <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
        <template #urlCustom="scope">
            <!-- <spna>{{ scope.scope.url }}</spna> -->
                <el-image
                    v-if="scope.scope.url != null && scope.scope.url != ''"
                    style="width: 20px; height: 20px; border: 1px solid #dcdfe6"
                    title="点击查看大图"
                    :src="scope.scope.url"
                    :preview-src-list="[scope.scope.url]"
                    preview-teleported
                 
                >
                </el-image>&nbsp;
                <span v-if="scope.scope.url != null && scope.scope.url != ''">{{ scope.scope.url }}</span>
        </template>
        </TableList>
     </div>
  

  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  ></Pagination>

  <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      v-if="dialogVisible"
      width="650px"
      :close-on-click-modal="false"
      :before-close="beforeDialog"
      top="18vh"
      draggable
                  destroy-on-close
    >
      <div class="dialog_div" style="height: 470px">
        <add-edit-background
          ref="addEditBackground"
          v-if="dialogVisible"
          @close-dialog="closeDialog"
          :editId="editId"
          @update-list="updateList"
          :imgObj="imgObj"
        >
        </add-edit-background>
      </div>
    </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw, h, computed, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {getBackgroundImageList, deletesBackgroundImage} from "network/focusFigure.js";
import AddEditBackground from "views/Background/AddEditBackground.vue";
import store from "../../store/index";
export default {
    name: "FocusFigure",
    props: {
        tableMaxHeight: Number,
    },
    components: {
        TableList,
        Pagination,
        AddEditBackground,
    },
    setup() {
        //这里定义一个结构体，用来保存项目信息
        const data = reactive({
        isDelect: computed(() => {
            return (
            store.state.isDelect ||
            JSON.parse(sessionStorage.getItem("isDelect"))
            );
        }),
        // 表格是否在加载中
        loading: true,
        loadingText: "加载中...",
        emptyText: "暂无数据",
        // 分页
        pagination: {
            currentPage: 1,
            pageSize: 20,
            total: 0,
        },
        //表格数据
        tableData: [],
        //表头数据
        headerData: [
            {
            label: "勾选框",
            type: "selection",
            width: "55",
            fixed: "left",
            },
            {
            label: "页面标注",
            prop: "title",
            width: "260",
            align: "left",
            noSetText: "未设置",
            type: "InputSearch",
            fixed: "left",
            },
            {
            label: "图片Url",
            prop: "url",
            align: "left",
            noSetText: "未设置",
            // isImg: true,
            custom: true,
            },
            {
            label: "发布时间",
            prop: "createTime",
            width: "240",
            align: "center",
            noSetText: "未设置",
            },
        ],
        multipleSelection: [], //选中行数据
        //筛选项
        search: {
            title: null,
        },
        dialogTitle: "",
        dialogVisible: false, //添加编辑弹窗
        editId: 0,
        imgObj: {}, //编辑对象
        });


        //挂载后调用函数获取项目数据
        onMounted(() => {
            getData(); 
        });


        // 获取列表
        const getData = async () => {
            data.loading = true;
            const obj = {
                title: data.search.title,
                pageIndex: data.pagination.currentPage,
                pageSize: data.pagination.pageSize,
            };
            const res = await getBackgroundImageList(obj);
            data.loading = false;
            if (res && res.code == 1) {
                data.pagination.total = res.totalCount;
                data.tableData = res.data;
            } else {
                data.loading = false;
                ElMessage.error(res.message);
            }
        };

        // 搜索
        const searchFnc = (val) => {
            if (val.prop && val.prop == "title") {
                data.search.title = val.value;
            }
            data.pagination.currentPage = 1;
            getData();
        };

        //更新列表
        const updateList = () => {
            getData();
        };


        // 分页
        const changePagination = (val) => {
            data.pagination = toRaw(val);
            updateList();
        };

        // 表格多选行处理
        const handleSelection = (row) => {
            data.multipleSelection = JSON.parse(JSON.stringify(row));
        };

        // 批量删除
        const deletes = () => {
        if (data.multipleSelection && data.multipleSelection.length == 0) {
                ElMessage.error("请选择一个或多个小程序背景图信息");
                return;
            }
            var ids = data.multipleSelection.map((item) => item.id);

            ElMessageBox({
                    title: "删除提示",
                message: h("p", null, [
                    h("span", null, "确定要删除【"),
                    h(
                        "b",
                        { style: "color: #fd5252;font-size:16px" },
                        `${data.multipleSelection.length}`
                    ),
                    h("span", null, "】个小程序背景图吗？ "),
                ]),
                showCancelButton: true,
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    // 开启按钮加载
                    instance.confirmButtonLoading = true;
                    instance.confirmButtonText = "确认中",
                    // 删除接口
                    deletesBackgroundImage(ids)
                    .then((result) => {
                    if (result && result.code == 1) {
                        done();
                        ElMessageBox.alert(result.message, "提示", {
                            confirmButtonText: "确认",
                        });
                        updateList();
                    } else {
                        done();
                        ElMessageBox.alert(result.message, "提示", {
                            confirmButtonText: "确认",
                        });
                    }
                    })
                    .catch((err) => {
                    done();
                    ElMessageBox.alert(err.message, "提示", {
                            confirmButtonText: "确认",
                        });
                    })
                } else {
                    done();
                }
                },
            // }).then(() => {
            //     var ids = data.multipleSelection.map((item) => item.id);
            //     deletesBackgroundImage(ids).then((res) => {
            //     if (res.code === 1) {
            //         ElMessageBox.alert(res.message, "提示", {
            //         confirmButtonText: "确认",
            //         });
            //         updateList();
            //     } else {
            //         ElMessageBox.alert(res.message, "提示", {
            //         confirmButtonText: "确认",
            //         });
            //     }
            //     });
            })
            .catch(() => {
                ElMessage("取消删除");
            });
        };

        // 添加
        const addBackground = () => {
            data.imgObj ={};
            data.editId = 0;
            data.dialogTitle = "添加背景图";
            data.dialogVisible = true;
        };

        //编辑
        const editFnc = (obj) => {
            data.dialogVisible = true;
            data.dialogTitle = "编辑背景图";
            data.editId = data.multipleSelection[0].id;
            data.imgObj = {
                id: data.multipleSelection[0].id,
                title: data.multipleSelection[0].title,
                url: data.multipleSelection[0].url,
            };
        }

        // 外层取消按钮
        const beforeDialog = () => {
            addEditBackground.value.onCancel();
            data.dialogVisible = false;
        };

        const closeDialog = () => {
            data.dialogVisible = false;
            data.imgObj = {};
        }

        //关闭添加编辑弹窗操作
        const addEditBackground = ref();
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
        return {
        //解构Data结构体，让模板可以直接调用Data里面的对象
        ...toRefs(data),
        addEditBackground,
        closeDialog,
        beforeDialog,
        // editBackground,
        editFnc,
        addBackground,
        deletes,
        handleSelection,
        changePagination,
        searchFnc,
        getData,
        updateList,
        btnInTable,
        btnLeftList,
        buttonList,
        btnOnList,
        btnHandle,
        doEvent,
        };


    }
}
</script>

<style>
.FocusFigure tr{
    height: 48.86px;
}
</style>